module.exports = __webpack_public_path__ + "static/media/dog-collar-tutorial-capa.93f0ccd8.jpg";